import React, { useEffect, useState } from "react";
import { FaEnvelope, FaPlus, FaGlobe } from "react-icons/fa";
import HeaderMainPage from "../../header/HeaderMainPage";

const EmailDomainPage = () => {
  const API_BASE = process.env.REACT_APP_ROBOMAN_API;

  const [emails, setEmails] = useState([]);
  const [loadingEmails, setLoadingEmails] = useState(true);
  const [domains, setDomains] = useState([
    { id: 1, domain: "yourdomain.com" },
  ]);

  const [newDomain, setNewDomain] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [selectedDomain, setSelectedDomain] = useState("");

  const fetchEmails = async () => {
    try {
      setLoadingEmails(true);

      const token = localStorage.getItem("access_token");

      const res = await fetch(`${API_BASE}/campaign/get_email_accounts/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token?.startsWith("Bearer ")
            ? token
            : `Bearer ${token}`,
        },
      });

      if (!res.ok) {
        throw new Error("Failed to fetch emails");
      }

      const data = await res.json();

      const formatted = (data?.email_accounts || []).map((email, index) => ({
        id: index + 1,
        email,
        status: "Active",
      }));

      setEmails(formatted);
    } catch (err) {
      console.error("Error fetching emails:", err);
      setEmails([]);
    } finally {
      setLoadingEmails(false);
    }
  };

  useEffect(() => {
    fetchEmails();
  }, []);

  const handleAddDomain = () => {
    if (!newDomain.trim()) return;

    setDomains((prev) => [
      ...prev,
      {
        id: Date.now(),
        domain: newDomain.trim(),
      },
    ]);

    setNewDomain("");
  };

  const handleAddEmail = () => {
    if (!newEmail.trim() || !selectedDomain) return;

    const fullEmail = `${newEmail.trim()}@${selectedDomain}`;

    setEmails((prev) => [
      ...prev,
      {
        id: Date.now(),
        email: fullEmail,
        status: "Active",
      },
    ]);

    setNewEmail("");
  };

  return (
    <div>
      <HeaderMainPage />

      <div className="min-h-screen bg-slate-50 bg-[radial-gradient(1200px_600px_at_10%_-10%,rgba(129,140,248,0.18),transparent),radial-gradient(900px_400px_at_90%_10%,rgba(56,189,248,0.14),transparent)] px-4 py-6 md:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Title */}
          <div className="mb-6">
            <h1 className="text-2xl md:text-3xl font-semibold bg-gradient-to-r from-gray-700 via-blue-700 to-fuchsia-700 bg-clip-text text-transparent">
              Email Accounts & Domains
            </h1>
            <p className="text-sm text-slate-600 mt-1">
              Manage your sending domains and email accounts for outreach.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* LEFT PANEL */}
            <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
              <div className="flex items-center gap-2 mb-4">
                <FaEnvelope className="text-indigo-600" />
                <h2 className="text-base font-semibold text-slate-900">
                  Default Email Accounts
                </h2>
              </div>

              <div className="space-y-3">
                {loadingEmails ? (
                  <div className="text-sm text-slate-500">Loading emails...</div>
                ) : emails.length === 0 ? (
                  <div className="text-sm text-slate-500">
                    No email accounts found
                  </div>
                ) : (
                  emails.map((item) => (
                    <div
                      key={item.id}
                      className="flex justify-between items-center p-3 rounded-xl bg-slate-50 border border-slate-200"
                    >
                      <span className="text-sm font-medium text-slate-800">
                        {item.email}
                      </span>
                      {/* <span className="text-xs text-emerald-600 font-medium">
                        {item.status}
                      </span> */}
                    </div>
                  ))
                )}
              </div>
            </div>

            {/* RIGHT PANEL */}
            <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
              <div className="flex items-center gap-2 mb-4">
                <FaPlus className="text-indigo-600" />
                <h2 className="text-base font-semibold text-slate-900">
                  Add Domain & Email
                </h2>
              </div>

              {/* Enterprise Feature Info */}
            <div className="space-y-4">
                <div className="rounded-xl bg-indigo-50 border border-indigo-100 p-4">
                    <p className="text-sm font-semibold text-indigo-700">
                    Enterprise Feature
                    </p>
                    <p className="text-sm text-indigo-600 mt-1">
                    Custom domains and email accounts are available only for enterprise users.
                    </p>
                </div>

                {/* Features List */}
                <div className="space-y-3 text-sm text-slate-600">
                    <div className="flex items-start gap-2">
                    <span className="mt-1 h-2 w-2 rounded-full bg-indigo-500" />
                    <p>Connect your own sending domains</p>
                    </div>
                    <div className="flex items-start gap-2">
                    <span className="mt-1 h-2 w-2 rounded-full bg-indigo-500" />
                    <p>Create unlimited email accounts</p>
                    </div>
                    <div className="flex items-start gap-2">
                    <span className="mt-1 h-2 w-2 rounded-full bg-indigo-500" />
                    <p>Improve deliverability with domain warmup</p>
                    </div>
                    <div className="flex items-start gap-2">
                    <span className="mt-1 h-2 w-2 rounded-full bg-indigo-500" />
                    <p>Advanced sending limits & rotation</p>
                    </div>
                </div>

                {/* CTA Button */}
                <button
                    onClick={() => window.location.href = "/enterprise/domains"}
                    className="w-full mt-4 bg-indigo-600 hover:bg-indigo-700 text-white py-2 rounded-xl font-medium transition"
                >
                    Setup Domains & Email Accounts
                </button>
            </div>
            </div>
          </div>
        </div>
      </div>

      {/* Optional Footer */}
      <div className="border-t border-slate-200 bg-white py-4 text-center text-sm text-slate-500">
        © 2026 Outreach. All rights reserved.
      </div>
    </div>
  );
};

export default EmailDomainPage;